var _WINDOW$document$docu, _WINDOW$document, _WINDOW$document$docu2;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getObjectKeys, isUndefined } from 'tsfn';
var WINDOW = global;
var STYLES = (_WINDOW$document$docu = (_WINDOW$document = WINDOW.document) === null || _WINDOW$document === void 0 ? void 0 : (_WINDOW$document$docu2 = _WINDOW$document.documentElement) === null || _WINDOW$document$docu2 === void 0 ? void 0 : _WINDOW$document$docu2.style) !== null && _WINDOW$document$docu !== void 0 ? _WINDOW$document$docu : {};
var PREFIXES = ['Webkit', 'Moz', 'ms'];
var cache = new Map();

var prefixStyleKey = function prefixStyleKey(key) {
  if (cache.has(key)) {
    return cache.get(key);
  }

  if (!isUndefined(STYLES[key])) {
    cache.set(key, key);
    return key;
  }

  var _iterator = _createForOfIteratorHelper(PREFIXES),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prefix = _step.value;
      var prefixedKey = "".concat(prefix).concat(key.charAt(0).toUpperCase()).concat(key.slice(1));

      if (!isUndefined(STYLES[prefixedKey])) {
        cache.set(key, prefixedKey);
        return prefixedKey;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  cache.set(key, key);
  return key;
};

export var prefixStyle = function prefixStyle(styles) {
  return getObjectKeys(styles).reduce(function (result, key) {
    var prefixedKey = prefixStyleKey(key); // FIXME
    // @ts-ignore

    result[prefixedKey] = styles[key];
    return result;
  }, {});
};
//# sourceMappingURL=index.js.map